<template>
	<div>
        <x-modal
            :wWidth="1080"
            v-if="requestAdditionalDocumentsModal.visible == true"
            @cancel="requestAdditionalDocumentsModalClose"
            @close="requestAdditionalDocumentsModalClose"
            @ok="requestAdditionalDocumentsSubmit"
            :draggable="true"
            :resizable="true"
            :loading="requestAdditionalDocumentsModal.loading"
            :okDisabled="requestAdditionalDocumentsButtonDisabled"
            okText="Request Additional Documents"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Request Additional Documents</div>

            <div class="container">

                <el-form :model="requestAdditionalDocumentsModal" label-width="140px">

                    <div class="mt-3 mb-4">
                        <p>
                            Applicant data collection complete. Ensure the privacy statement and credit guide are sent to the customer. The
                            customer will be notified of the list of documentation to return
                        </p>
                    </div>

                    <email-sending-options></email-sending-options>

                    <email-recipients
                        v-if="(emailBuilder.sendEmail || emailBuilder.sendSms)"
                        :recipientLimit="0"
                        recipientType="applicant"
                        :recipientAllowCreate="false"
                        :hideCC="!emailBuilder.sendEmail ? true : false"
                        :hideBCC="!emailBuilder.sendEmail ? true : false"
                    ></email-recipients>

                    <email-task v-model="emailBuilder.task"></email-task>

                    <el-divider v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"></el-divider>

                    <email-markup-multi
                        v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"
                        action="request-additional-documents"
                        :documents="true"
                    ></email-markup-multi>
                </el-form>
            </div>
        </x-modal>

        <!-- Complete modal -->
        <x-modal
            width="650"
            v-if="submitModal.visible == true"
            @cancel="submitModal.visible = false"
            @close="submitModal.visible = false"
            @ok="completeStepButton"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            okText="Request Additional Documents"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Request Additional Information</div>

            <div class="container">
                <div class="row pt-0 amb-modal-body">
                    <div class="col-12 mb-3">
                        <div class="my-3">
                            <p>
                                Applicant data collection complete. Ensure the privacy statement and credit guide are sent to the customer. The
                                customer will be notified of the list of documentation to return
                            </p>
                        </div>

                        <!-- send to customer -->
                        <div class="mb-3">
                            <application-checkbox
                                style="display: none"
                                type="hidden"
                                class="mb-2"
                                :checked.sync="submitModal.formData.sendEmail"
                            >
                                Send email to customer?
                            </application-checkbox>
                        </div>

                        <div v-if="submitModal.formData.sendEmail">
                            <p class="mb-1">
                                <strong>To</strong>
                            </p>
                            <div v-for="(applicant, index) in applicants" :key="applicant.applicantId">
                                <div class="d-flex align-items-center amb-toggle-row-modal mb-1">
                                    <div class="amb-table-check-container mr-2">
                                        <input
                                            class="table-checkbox"
                                            type="checkbox"
                                            :value="{ id: applicant.applicantId, email: applicant.email }"
                                            v-model="submitModal.formData.to"
                                            :checked="submitModal.formData.to.some((to) => to.email == applicant.email && to.id == applicant.id)"
                                            :disabled="!submitModal.formData.sendEmail"
                                        />
                                        <span class="amb-table-checkmark"></span>
                                    </div>
                                    <p>{{ applicant.firstName }} {{ applicant.lastName }} ({{ applicant.email }})</p>
                                    <b-badge variant="primary" v-if="applicant.use_alias">Primary Applicant Email</b-badge>
                                </div>
                                <div class="d-flex align-items-center amb-toggle-row-modal mb-1" v-if="applicant.email2">
                                    <div class="amb-table-check-container mr-2">
                                        <input
                                            class="table-checkbox"
                                            type="checkbox"
                                            :value="{ id: applicant.applicantId, email: applicant.email2 }"
                                            v-model="submitModal.formData.to"
                                            :checked="submitModal.formData.to.some((to) => to.email == applicant.email2 && to.id == applicant.id)"
                                            :disabled="!submitModal.formData.sendEmail"
                                        />
                                        <span class="amb-table-checkmark"></span>
                                    </div>
                                    <p>
                                        {{ applicant.firstName }} {{ applicant.lastName }} ({{ applicant.email2 }})
                                        <span class="ml-2 badge badge-secondary btn-light-blue">Secondary</span>
                                    </p>
                                </div>
                            </div>

                            <multi-input
                                :model.sync="submitModal.formData.cc"
                                :disabled="!submitModal.formData.sendEmail"
                                label="Cc"
                            ></multi-input>

                            <application-input
                                class="input-belt mb-3"
                                v-model="submitModal.formData.subject"
                                :disabled="!submitModal.formData.sendEmail"
                            >
                                Subject
                            </application-input>

                            <div class="input-belt mb-4">
                                <h3 for="email-comments">Email Comments</h3>
                                <small>Enter any notes or comments to be included as 'broker notes' in email to the customer</small>

                                <summernote
                                    :model.sync="submitModal.formData.emailComments"
                                    :disabled="!submitModal.formData.sendEmail"
                                ></summernote>

                                <a href="#" class="text-btn-l-blue-bold mt-2 text-right" @click.prevent="previewEmail">
                                    <i class="fas fa-eye ml-1"></i>
                                    Preview Email
                                </a>
                            </div>
                        </div>

                        <!-- document return checklist -->
                        <div v-if="documents" class="input-belt mb-3">
                            <h3>Documents to be returned by Customer</h3>
                            <small class="mb-2">Select documents the customer must upload</small>

                            <application-document-table
                                :documents="documents"
                                :applicants="applicants"
                                :selected-documents.sync="submitModal.formData.docsToBeReturned"
                            ></application-document-table>
                        </div>
                    </div>
                </div>
            </div>
        </x-modal>
	</div>
</template>


<script>
	import { Message } from "element-ui"
    import { mapGetters } from "vuex"
	import DefaultTemplate from "../application-steps/scripts/DefaultTemplate"
	import ApplicationDocumentTable from "@ambition/components/application-steps/application-document-list/ApplicationDocumentTable"
    import EmailSendingOptions from "@ambition/components/messages/EmailSendingOptions.vue"
    import EmailRecipients from "@ambition/components/messages/EmailRecipients"
	import EmailAttachments from "@ambition/components/messages/EmailAttachments"
	import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
	import EmailTask from "@ambition/components/messages/EmailTask"

	export default {
		props: {
			open: Boolean,
			applicants: Array,
			documentsList: Array,
		},
		components: {
			"application-document-table": ApplicationDocumentTable,
            EmailSendingOptions,
            EmailRecipients,
			EmailAttachments,
			EmailMarkupMulti,
			EmailTask,
		},
		data() {
			return {
                requestAdditionalDocumentsModal: {
					sendEmail: true,
					visible: false,
					loading: false,
				},
				emailTemplate: null,
				submitModal: {
					formData: {
						emailComments: "",
						subject: null,
						to: [],
						cc: "",
						sendEmail: false,
						remindMe: new Date(),
						taskName: "",
						time: "17:00",
						docsToBeReturned: [],
					},
					visible: false,
				},
				loading: false,
			}
		},
		methods: {
            requestAdditionalDocumentsModalClose() {
				this.$store.dispatch("builderEmail/resetEmail")
				this.requestAdditionalDocumentsModal.loading = false
				this.requestAdditionalDocumentsModal.visible = false
			},
			requestAdditionalDocumentsSubmit() {
                this.requestAdditionalDocumentsModal.loading = true

				axios.post(`/api/applications/${this.$store.getters.initAppData.id}/additional-documents`, this.emailBuilder, {
                    headers: { Authorization: "Bearer " + this.$store.getters.token }
                })

                // create application task
                if (_.get(this.emailBuilder, "task.create", false)) {
                    this.$store.dispatch("statusIndicators/changeStatus", {
                    stage: "createTask",
                    token: this.$store.getters.token,
                    remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
                    taskName: this.emailBuilder.task.name,
                    time: this.emailBuilder.task.time,
                    userId: this.emailBuilder.task.userId,
                    appId: this.$store.getters.initAppData.id
                    })
                }

                // create recipient tasks
                if (_.get(this.emailBuilder, "recipients", false)) {
                    this.emailBuilder.recipients.forEach(recipient => {
                    if (_.get(recipient, "template.task.create", false)) {
                        this.$store.dispatch("statusIndicators/changeStatus", {
                        stage: "createTask",
                        token: this.$store.getters.token,
                        remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
                        taskName: recipient.template.task.name,
                        time: recipient.template.task.time,
                        userId: recipient.template.task.userId,
                        appId: this.$store.getters.initAppData.id
                        })
                    }
                    })
                }

                this.requestAdditionalDocumentsModalClose()

                swal({
                    title: "Success",
                    text: "Request additional documents submitted!",
                    type: "success",
                    showCancelButton: false,
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#2493ef",
                    reverseButtons: false,
                })

                if (this.$router.currentRoute.name !== "Conditioning") {
                    this.$router.push({ name: "Conditioning" })
                }
			},
			async getDefaultTemplate() {
				try {
					//   ... template id or stage for this;
					let request = new DefaultTemplate(1, this.$store.getters.token)
					let res = await request.handle()
					this.emailTemplate = res

					if (this.emailTemplate) {
						this.submitModal.formData.subject = this.emailTemplate.subject
					}
				} catch (err) {
					console.error(err)
				}
			},
			previewEmail() {
				axios
					.post("/admin/preview/mail/" + this.$store.getters.initAppData.id, {
						notes: this.submitModal.formData.emailComments,
						status_id: "additional-request",
						documents: this.submitModal.formData.docsToBeReturned,
					})
					.then((res) => {
						window.open("/admin/preview/mail/" + this.$store.getters.initAppData.id + "?status_id=additional-request")
					})
					.catch((err) => {
						console.error(err.response.data)
					})
			},

			completeStepButton() {
				this.loading = true
				const header = {
					headers: { Authorization: "Bearer " + this.$store.getters.token },
				}
				axios
					.post(
						`/api/applications/${this.$store.getters.initAppData.id}/additional-documents`,
						{
							to: this.submitModal.formData.to,
							cc: this.submitModal.formData.cc,
							comment: this.submitModal.formData.emailComments,
							subject: this.submitModal.formData.subject,
							documents: this.submitModal.formData.docsToBeReturned,
						},
						header
					)
					.then((res) => {
						this.loading = false
						this.$bus.$emit("additional-information-requested", true)
						this.submitModal.visible = false
						Message({
							message: "Additional Documents Requested",
							type: "success",
						})
					})
					.catch((err) => {
						this.loading = false
						console.error(err)
						Message({
							message: "Request Failed",
							type: "error",
						})
					})
			},
		},
		computed: {
			documents: {
				set(newVal, oldVal) {
					this.documentsList = newVal
				},
				get() {
					return this.documentsList.map((document) => {
						return Object.assign(document, { displayName: document.name })
					})
				},
			},
            ...mapGetters({
				emailBuilder: "builderEmail/getEmail",
                templatesLoaded: "builderEmail/checkTemplatesLoaded",
			}),
			requestAdditionalDocumentsButtonDisabled() {
				if (!this.emailBuilder.sendEmail && !this.emailBuilder.sendSms) return true
                if (this.emailBuilder.delaySending && !this.emailBuilder.sendAt) return true
                if (!this.templatesLoaded) return true
				if (_.size(this.emailBuilder.recipients) >= 1 && !this.requestAdditionalDocumentsModal.loading) return false
				return true
			},
		},
		watch: {
			"submitModal.visible"(newVal, oldVal) {
				this.$emit("update:open", newVal)
			},
            "requestAdditionalDocumentsModal.visible"(newVal, oldVal) {
				this.$emit("update:open", newVal)
			},
			open(newVal, oldVal) {
                if (Ambition.useEmailBuilder()) {
                    this.requestAdditionalDocumentsModal.visible = newVal
                } else {
                    this.submitModal.visible = newVal
                    if (newVal) {
                        this.getDefaultTemplate()
                    }
                }
			},
		},
	}
</script>
